import { useRef, useMemo } from 'react';

import BulkUpload from '@Components/BasicComponents/BulkUpload';
import Validate from '@Components/Validate';

import { checkPhotoNames } from '@/utils/names';
import { fileRequired, filesUploaded } from '@/utils/errors/list';
import { getSetting } from '@/utils/settings';

import useNotification from '@/hooks/notifications';
import useIbmS3Uploader from '@/hooks/useIbmS3UploaderNew';

export default function AudioBulkUpload ({selector}) {
	const {files, setFile, removeFileByUid} = selector();
	const {openNotification} = useNotification();

	const useIbmS3UploaderRef = useRef(useIbmS3Uploader({
		setFile,
		removeFile: removeFileByUid,
		bucketPrefix: 'photos/',
		bucketName: getSetting('ibmS3TempBucket'),
	}));
	const {handleUpload, handleRemove} = useIbmS3UploaderRef.current;


	const beforeUpload = (file) => {
		return checkPhotoNames({openNotification})(file);
	};

	const requirements = useMemo(() => [fileRequired, filesUploaded], []);

	return (
		<Validate requirements={requirements}>
			<BulkUpload
				value={files}
				handleUpload={handleUpload}
				accept="image/jpeg"
				beforeUpload={beforeUpload}
				handleRemove={handleRemove}
				required
			/>
		</Validate>
	);
}